function PrivacyTamofishi() {
  return (
    <div style={{ maxWidth: "680px", margin: "0 auto", padding: "2rem 1rem", lineHeight: "1.6", overflowY: "scroll", height: "100vh" }}>
      <h1 style={{ textAlign: "center", marginTop: "20px", marginBottom: "20px" }}>Tamofishi</h1>
      <hr style={{ marginTop: "20px", marginBottom: "20px" }} />
      <h1>Tamofishi Privacy Policy</h1>
      <p><em>Last updated: May 30, 2026</em></p>

      <p>
        Tamofishi is a pixel aquarium simulator. This policy explains what information the app
        accesses and how it is used.
      </p>

      <h2>Information We Collect</h2>
      <p>
        Tamofishi does not collect, store, or transmit any personal information. The app does not
        require an account, does not connect to any external servers, and does not include analytics
        or tracking of any kind.
      </p>
      <p>
        The only data the app handles is your tank state — the creatures, plants, and decorations
        in your aquarium. This is saved locally on your device and never leaves it.
      </p>

      <h2>In-App Purchases</h2>
      <p>
        Tamofishi offers optional one-time tips via Apple's in-app purchase system. These
        transactions are processed entirely by Apple. We do not receive or store any payment
        information.
      </p>

      <h2>Data Sharing</h2>
      <p>
        We do not share any data with third parties. There is nothing to share.
      </p>

      <h2>Children's Privacy</h2>
      <p>
        Tamofishi does not collect any personal information from anyone, including children under 13.
      </p>

      <h2>Changes to This Policy</h2>
      <p>
        We may update this policy from time to time. The date at the top of this page reflects
        the most recent revision.
      </p>

      <h2>Contact</h2>
      <p>
        For questions, contact: <a href="mailto:privacy@sethduncan.com">privacy@sethduncan.com</a>
      </p>
    </div>
  );
}

export default PrivacyTamofishi;
